/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S2_Li2Inputs */

const en_guide_json_schema_s2_li2 = /** @type {(inputs: Guide_Json_Schema_S2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>required</strong>: Array of property names that must be present`)
};

const ko_guide_json_schema_s2_li2 = /** @type {(inputs: Guide_Json_Schema_S2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>required</strong>: 반드시 존재해야 하는 속성 이름의 배열`)
};

const ja_guide_json_schema_s2_li2 = /** @type {(inputs: Guide_Json_Schema_S2_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>required</strong>: 存在しなければならないプロパティ名の配列`)
};

/**
* | output |
* | --- |
* | "<strong>required</strong>: Array of property names that must be present" |
*
* @param {Guide_Json_Schema_S2_Li2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s2_li2 = /** @type {((inputs?: Guide_Json_Schema_S2_Li2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S2_Li2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s2_li2(inputs)
	if (locale === "ko") return ko_guide_json_schema_s2_li2(inputs)
	return ja_guide_json_schema_s2_li2(inputs)
});